module.exports = __webpack_public_path__ + "img/video1.782b3f9c.webp";